export default function BurgerMenuIcon({ white = true }: { white: boolean }) {
	return white ? (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M24.3999 11L8.3999 11"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M20.7998 16H8.79981"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M24.3999 21L8.3999 21"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	) : (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M24.4 11L8.40003 11"
				stroke="#061120"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M20.8 16H8.79999"
				stroke="#061120"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M24.4 21L8.40003 21"
				stroke="#061120"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}
